import Vue from 'vue';
import Vuex from 'vuex';
import {IConvertState} from './modules/convert';

Vue.use(Vuex);

export interface IRootState {
	convert: IConvertState;
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
